import {
  SORTING_OPTIONS,
  SortingOrder,
  SortingOptions,
} from "components/EditorHome/Constants";
import { isArray } from "lodash";

/**
 * @description - Sort templates data
 * @param {Array<any>} templates temlates list
 * @param {string} sortCriteria sorting option
 * @param {string} sortOrder sorting order
 * @returns {Array<any>} - sorted data
 */
export const getSortedTemplateData = (
  templates: Array<any>,
  sortCriteria: string,
  sortOrder: string
): Array<any> => {
  try {
    if (isArray(templates)) {
      if (sortCriteria == SortingOptions.TEMPLATE_NAME) {
        return templates.sort((a, b) => {
          const nameA = a[sortCriteria].toLowerCase();
          const nameB = b[sortCriteria].toLowerCase();
          if (nameA < nameB) {
            return sortOrder === SortingOrder.ASC ? -1 : 1;
          }
          if (nameA > nameB) {
            return sortOrder === SortingOrder.ASC ? 1 : -1;
          }
          return 0;
        });
      } else {
        return templates.slice().sort((a, b) => {
          const dateA = new Date(a[sortCriteria]);
          const dateB = new Date(b[sortCriteria]);

          if (sortOrder === SortingOrder.ASC) {
            return dateA.getTime() - dateB.getTime();
          } else {
            return dateB.getTime() - dateA.getTime();
          }
        });
      }
    } else {
      return templates;
    }
  } catch (e) {
    return templates;
  }
};

/**
 * @description - get label from value

 * @param {string} value constant value
 * @returns {string} - constant label
 */
export const getOptionLabel = (value: string, criteria: any): string => {
  try {
    const label = criteria.find((option: any) => option.value === value)?.label;
    if (label) {
      return label;
    } else {
      return SORTING_OPTIONS[0].label;
    }
  } catch (e) {
    return SORTING_OPTIONS[0].label;
  }
};
